var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var Edit = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 20 20" }),
        React.createElement("path", { d: "M18.35,1.65 C16.49,-0.22 13.81,1.49 12.65,2.65 L2.65,12.65 C2.59564349,12.6990785 2.55439685,12.7609484 2.53,12.83 L2.53,12.83 L0.53,18.83 C0.465513664,19.0087657 0.512567507,19.2087446 0.65,19.34 C0.7384842,19.4408416 0.865844849,19.4990636 1,19.5 C1.05290514,19.5095576 1.10709486,19.5095576 1.16,19.5 L7.16,17.5 L7.16,17.5 C7.22905157,17.4756032 7.29092154,17.4343565 7.34,17.38 L17.34,7.38 C18.51,6.19 20.22,3.51 18.35,1.65 Z M1.79,18.21 L3.22,13.93 L6.07,16.78 L1.79,18.21 Z M7,16.29 L3.71,13 L13,3.71 L16.29,7 L7,16.29 Z M17,6.29 L13.73,3 C14.52,2.35 16.39,1.07 17.65,2.33 C18.91,3.59 17.63,5.48 17,6.27 L17,6.29 Z" })));
};
export default Edit;
